<template>
  <e-charts
    ref="lineChart"
    autoresize
    :options="line"
    theme="theme-color"
    auto-resize
    @mousemove="$emit('mousemove', $event)"
    @click="$emit('click', $event)"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/line'
import theme from '@core/components/charts/echart/theme.json'

ECharts.registerTheme('theme-color', theme)

function buildOptions(xData, seriesData) {
  return {
    grid: {
      left: '36px',
      right: '8px',
      top: '8px',
      bottom: '28px',
      containLabel: false,
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(13,51,73,0.92)',
      borderColor: '#E86A10',
      borderWidth: 1,
      textStyle: { color: '#fff', fontSize: 13 },
      formatter(params) {
        const p = params[0]
        return `Tempo: <b>${p.axisValue}</b><br/>Audiência: <b>${p.data}</b>`
      },
    },
    xAxis: [{
      show: true,
      boundaryGap: false,
      data: xData || [],
      axisLabel: { color: '#94a3b8', fontSize: 11 },
      axisLine: { lineStyle: { color: '#334155' } },
      splitLine: { show: false },
    }],
    yAxis: {
      type: 'value',
      axisLabel: { color: '#94a3b8', fontSize: 11 },
      splitLine: { lineStyle: { color: '#1e3a4a', type: 'dashed' } },
    },
    series: [{
      name: 'Audiência',
      type: 'line',
      showSymbol: false,
      smooth: true,
      lineStyle: { color: '#E86A10', width: 2 },
      itemStyle: { color: '#E86A10' },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: 'rgba(232,106,16,0.45)' },
            { offset: 1, color: 'rgba(232,106,16,0.02)' },
          ],
        },
      },
      data: seriesData || [],
    }],
  }
}

export default {
  name: 'GraficosCustom',
  components: { ECharts },
  props: ['dataChart', 'labelChart'],
  data() {
    return {
      line: buildOptions(this.dataChart, this.labelChart),
    }
  },
  methods: {
    updatedChart(seriesData, axisData) {
      this.line = buildOptions(axisData, seriesData)
    },
  },
}
</script>

<style scoped>
.echarts {
  width: 100% !important;
  height: 100% !important;
}
</style>
